export default __webpack_public_path__ + "static/media/18.6357c0bb.jpg";